import { Signal } from './Signal';
import { Registry } from './Registry';
import { PropertyObserver, PropertyChanged, observeProperties } from './Observer';




/**
 * A common model class that has getters and setters
 */
export class Model implements PropertyObserver {

	/**
	 * Raised when a property's value has changed.
	 *
	 * @event
	 */
	public propertyChange:Signal<PropertyChanged>;


	constructor( dto?:object ) {
		if( dto ) {
			Object.assign( this, dto );
			observeProperties( this );
		}
	}
}







/**
 * A registry for modelName to Model class mappings
 */
export class ModelRegistry extends Registry<string,object,Model> {}

/**
 * This helper function maps objects in the given data on registered models
 * @param data The data structure to map models
 * @param registry The registry to lookup model defintions
 * @param property the object property to lookup keys
 */
export function map( data:any, registry:ModelRegistry, lookup?:( obj:object ) => string ) {

	if( !lookup ) lookup = ( obj:any ) => obj.modelName || 'default';

	// handle arrays
	if( Array.isArray( data ) ) {
		data = data.map( item => map( item, registry, lookup ) );
	}

	// handle objects
	if( data && data.constructor == Object ) {

		let factory = registry.get( lookup( data ) );

		Object.keys( data ).forEach( name => {
			data[ name ] = map( data[ name ], registry, lookup );
		});

		return ( factory ) ? factory( data ) : data;
	}

	return data;
}
